/* eslint-disable */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export function generalInit() {
  window.onload = function() {
    preLoaderAnimations();

    if(jQuery('.single-carta').length > 0) {
      $(document).trigger('showPopupCarta');
    }

    // Frontpage
    if($('.frontpage-page').length > 0) {
      frontPage();
      initSwiper();
    }

    // CARTA
    if($('.carta-page').length > 0) {
      carta();
    }

    // Change pages
    $(document).on('click', '.ajax-link a, .ajax-link-carta, .ajax-link-general', function (event) {
      event.preventDefault();
      //showLoaderPage(textPage);

      var url      = $(this).attr('href'),
          postId   = $(this).data('postid'),
          postType = $(this).data('posttype');

      if ($(this).parent().parent().hasClass('slug-regala')) {
          postType = 'regala';
      }

      if ($(this).parent().parent().hasClass('slug-reservas')) {
          postType = 'reservas';
      }

      changePage(postId, postType, false, url);
    });

    // Accordion carta
    $(document).on('click', '.toggle', function(e) {
      e.preventDefault();
      var openCloseIcon = $(this).find('.open-close-icon');
      var id = openCloseIcon.attr('id');
      // crossAnimation($(this))

      var $this = $(this);

      if ($('.' + $(this).data('section')).hasClass('show')) {
        $('.' + $(this).data('section')).removeClass('show');
        $('.' + $(this).data('section')).slideUp(350);
        $this.addClass('no-show');

        document.querySelector('#' + id).setDirection(-1);
        document.querySelector('#' + id).play();

      } else {
        // $this.parent().parent().find('.categorias').removeClass('show');
        // $this.parent().parent().find('.categorias').slideUp(350);
        $('.' + $(this).data('section')).addClass('show');
        $('.' + $(this).data('section')).slideDown(350);
        $this.removeClass('no-show');

        document.querySelector('#' + id).setDirection(1);
        document.querySelector('#' + id).play();
      }
    });

    iconOpenClose();
  }
}

function iconOpenClose(){
  if ($('.open-close-icon').length > 0) {
    $('.open-close-icon').each(function (){
      var id = $(this).attr('id');

      if ($(this).hasClass('open')) {
        document.querySelector('#' + id).setDirection(1);
        document.querySelector('#' + id).play();
        $(this).addClass('open')
      }
    });
  }
}

function initSwiper() {
  var swiper = new Swiper(".platos", {
    slidesPerView: 1, // Muestra múltiples slides a la vez
    centeredSlides: true, // Centra el slide activo
    loop: true,
    autoHeight: false,
    spaceBetween: 0, // Añade espacio entre los slides
    navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      500: {
          slidesPerView: 1.8,
          spaceBetween: 10,
      },
      900: {
          slidesPerView: 2,
          spaceBetween: 10,
      },
  },
  });

  swiper.on('realIndexChange', function () {
    let newIndex = this.realIndex;
    console.log(newIndex);
    // let newSlide = jQuery('.swiper-slide').eq(newIndex);
    let title = jQuery('.swiper-slide-'+newIndex).data('title');

    jQuery('#section-slider .cartel-bg .bottom .title').html(title);
  });
}

function frontPage() {
  // Añade el subrayado a los títulos
  if ($('.texto-reserva .texto em').length > 0) {
    $('.texto-reserva .texto em').append('<lottie-player id="subrayado-em" class="subrayado-em on-focus-animation" src="/wp-content/themes/bajoquetabar/resources/images/home/lotties/BAJOQUETA-BAR.json" background="transparent" speed="1"></lottie-player>');
  }

  // PARALLAX
  gsap.registerPlugin(ScrollTrigger);

  // Selecciona las imágenes a las que quieres aplicar el efecto parallax
  let imagesReserva = gsap.utils.toArray('.images-reserva');
  let imagesHuerta = gsap.utils.toArray('.images-section-three');

  if (ScrollTrigger.isTouch !== 1 || window.innerWidth > 900) {
    // Aplicar el trigger de scroll al elemento .section-two
    imagesReserva.forEach((img) => {
      gsap.to(img, {
        yPercent: -80,
        ease: 'none',
        scrollTrigger: {
          trigger: '.texto-reserva',
          start: 'top bottom', // cuando la parte superior del trigger llega al final de la ventana
          end: 'bottom top', // cuando la parte inferior del trigger llega al inicio de la ventana
          scrub: true, // suaviza el efecto parallax
          markers: false,
        }
      });
    });
  }

  imagesHuerta.forEach((img) => {
    gsap.to(img, {
      yPercent: -80,
      ease: 'none',
      scrollTrigger: {
        trigger: '#section-three',
        start: 'top bottom', // cuando la parte superior del trigger llega al final de la ventana
        end: 'bottom top', // cuando la parte inferior del trigger llega al inicio de la ventana
        scrub: true, // suaviza el efecto parallax
        markers: false,
      }
    });
  });

  // Activar animaciones
  if($(".on-focus-animation").length > 0){
    let onFocusAnimation = document.querySelectorAll(".on-focus-animation");

    onFocusAnimation.forEach(function (elemento){
      ScrollTrigger.create({
        trigger: elemento,
        start: "top 70%",
        end: "bottom 0",
        onEnter: function (){
          // const player = document.querySelector("."+$(elemento).attr("class"));
          elemento.setDirection(1);
          elemento.play();
        },
        markers: false,
      });
    })
  }

  // On hover animation
  if (".on-hover-animation-container") {
    let onHoverAnimationContainer = document.querySelectorAll(".on-hover-animation-container");
      onHoverAnimationContainer.forEach(function (elemento) {
        elemento.addEventListener("mouseover", (event) => {
          let animation = elemento.querySelector('.on-hover-animation');
          animation.setDirection(1);
          animation.play();
      });

      elemento.addEventListener("mouseleave", (event) => {
        let animation = elemento.querySelector('.on-hover-animation');
          animation.setDirection(-1);
          animation.play();
      });
    });
  }
}

function preLoaderAnimations() {
  if($('.bajoquetabar-pre-loader').length > 0) {
    const tlPreload = gsap.timeline();

    let imgTopRotation = -1.75,
        imgTopty = "-19%",
        imgLefty = "17%",
        imgRighty = "-8%";

    if ( window.matchMedia("(max-width: 900px)").matches && window.matchMedia("(min-width: 501px)").matches ) {
      imgTopRotation = 12.44;
      imgTopty = "-80%";
      imgLefty = "64%";
      imgRighty = "81%";
    }
    else if( window.matchMedia("(max-width: 500px)").matches ) {
      imgTopRotation = 12.44;
      imgTopty = "-15%";
      imgLefty = "27%";
      imgRighty = "39%";
    }

    tlPreload.to(".img-container-top", {
        y: imgTopty,
        delay: 0.7
    })
    .to(".img-container-top img", {
      duration: 1.2,
      rotation: imgTopRotation
    }, "-=1") // Esto hará que la animación de rotación comience al mismo tiempo que la animación anterior
    .to(".img-container-left", {
        y: imgLefty,
    })
    .to(".img-container-right", {
      y: imgRighty,
      onComplete: function() {
        setTimeout(() => {
          $('.bajoquetabar-pre-loader').addClass('hide-preloader');

          // Init show popup trigger
          if(jQuery('.home').length > 0){
            $(document).trigger('showPopupHome');
          }
        }, 700);
      }
    });
  }
}

function carta() {
  // PARALLAX
  gsap.registerPlugin(ScrollTrigger);

  // Crear una instancia de TimelineLite o TimelineMax
  let tl = gsap.timeline();

  // Definir la animación que queremos que se ejecute en la imagen
  tl.add(
    gsap.to(".bg-scroll", {
        opacity: 1,  // Asumiendo que quieres que vaya a -400 directamente basado en tu código original
      ease: "linear",
    }),
  )

  tl.add(
    gsap.to(".bg-start", {
      opacity: 0,  // Asumiendo que quieres que vaya a -400 directamente basado en tu código original
      ease: "linear",
    }),
  )

  // Aplicar el trigger de scroll al elemento .section-two
  ScrollTrigger.create({
    trigger: ".section-carta",
    start: "top 60%",
    end: "bottom 0",
    // scrub: 1,
    // pin: true,
    animation: tl,
    markers: false,
    toggleActions: "play none resume reverse"
  });

  // FIRMA LE ATIENDE ANIMACIÓN
  if($(".le-atiende").length > 0){
    let leAtiendeFirma = document.querySelectorAll(".le-atiende");

    leAtiendeFirma.forEach(function (elemento){
      ScrollTrigger.create({
        trigger: elemento,
        start: "top 70%",
        end: "bottom 0",
        onEnter: function (){
          // const player = document.querySelector("."+$(elemento).attr("class"));
          elemento.setDirection(1);
          elemento.play();
        },
        markers: false,
      });
    })
  }

  // FIRMA LE ATIENDE ANIMACIÓN
  if($(".lottie-qty").length > 0){
    let lottieQty = document.querySelectorAll(".lottie-qty");

    lottieQty.forEach(function (elemento){
      ScrollTrigger.create({
        trigger: elemento,
        start: "top 80%",
        end: "bottom 0",
        onEnter: function (){
          // const player = document.querySelector("."+$(elemento).attr("class"));
          elemento.setDirection(1);
          elemento.play();
        },
        markers: false,
      });
    })
  }

  if($(".plato-destacado").length > 0){
    // Plato subrayado animación
    let platoDestacado = $('.plato-destacado');

    if(platoDestacado.length > 0) {
      platoDestacado.each(function (index, element) {
        let animation = $(element).data('animation');

        $(element).find('em').append('<span class="animation-container"><lottie-player class="lottie-plato-destacado" src="'+animation+'" background="transparent" speed="1"> </lottie-player></span>');
      });
    }

    if($(".lottie-plato-destacado").length > 0){
      // plato-destacado ANIMACIÓN
      let lottiePlatoDestacado = document.querySelectorAll(".lottie-plato-destacado");

      lottiePlatoDestacado.forEach(function (elemento){
        ScrollTrigger.create({
          trigger: elemento,
          start: "top 80%",
          end: "bottom 0",
          onEnter: function (){
            // const player = document.querySelector("."+$(elemento).attr("class"));
            elemento.setDirection(1);
            elemento.play();
          },
          markers: false,
        });
      })
    }
  }

}

/*
* AJAX CALLS
 */
function changePage(postId, postType, reload, urlLink) {

  const tlPreloadPagesCapa1 = gsap.timeline();
  const tlPreloadPagesCapa2 = gsap.timeline();

  let capa1 = $(".bajoquetabar-pre-loader-pages .capa1"),
      capa2 = $(".bajoquetabar-pre-loader-pages .capa2");

  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php',
    dataType: 'json',
    data: {
      action  : 'bajoquetabar_get_page',
      postId  : postId,
      postType: postType,
    },
    beforeSend: function() {
      tlPreloadPagesCapa1.to(capa1, {
        "--mask": "0",
      })
      tlPreloadPagesCapa2.to(capa2, {
        "--mask": "0",
        delay: 0.2
      });

      $('.header-carta.active').removeClass('active');
    },
    success(res) {
      $('.header-carta.'+postId).addClass('active');
      setTimeout(() => {
        $("html, body").animate({scrollTop: 0}, 200);
        // PRINT PAGE
        $('.page__content').html(res.data.html);

        // Is carta post
        console.log( postType );
        if ( postType === 'carta' ) {
          console.log( 'entra' );
          carta();
          $('.header-bottom').show();
        }
        else {
          $('.header-bottom').hide();
        }

        // HIDE MOBILEMENU
        $('header nav').removeClass('menu-mobile-open');
        $('.toggle-mobile-menu .close').hide();
        $('.toggle-mobile-menu .open').show();

        if(res.data.popup === 'home'){
          $(document).trigger('showPopupHome');
        }
        else if(res.data.popup === 'carta'){
          $(document).trigger('showPopupCarta');
        }

      }, 400);

      setTimeout(function (){
        iconOpenClose();
      }, 1000)

      // Preload capa1
      tlPreloadPagesCapa1.to(capa1, {
        "--direction": "-90deg",
        // duration: 1,
      })
      .to(capa1, {
        "--mask": "100%",
          // delay: 1,
          ease: "none",
      })
      .to(capa1, {
          "--direction": "90deg",
          duration: 0,
          // delay: 1,
          ease: "none",
      })

      // Preload capa2
      tlPreloadPagesCapa2.to(capa2, {
        "--direction": "-90deg",
        // duration: 1,
      })
      .to(capa2, {
        "--mask": "100%",
          // delay: 1,
          ease: "none",
      })
      .to(capa2, {
          "--direction": "90deg",
          duration: 0,
          // delay: 1,
          ease: "none",
      })

      // Change url
      window.history.pushState({ path: urlLink }, '', urlLink);
    },
  });
}
